export const StarIcon = () => {
    const spikes = 5;
    const outerRadius = 50;
    const innerRadius = 25;
    const step = Math.PI / spikes;

    const points = Array.from({ length: 2 * spikes }).map((_, i) => {
        const radius = i % 2 === 0 ? outerRadius : innerRadius;
        const angle = i * step - Math.PI / 2;
        const x = radius * Math.cos(angle);
        const y = radius * Math.sin(angle);
        return `${x},${y}`;
    }).join(' ');

    return (
        <svg width="40" height="40" viewBox="-60 -60 120 120">
            <polygon points={points} fill="#fff" stroke="#333" strokeWidth="2" />
        </svg>
    );
};
